import { render, staticRenderFns } from "./AlfRelatedOne.vue?vue&type=template&id=237eebd9&scoped=true&"
import script from "./AlfRelatedOne.vue?vue&type=script&lang=js&"
export * from "./AlfRelatedOne.vue?vue&type=script&lang=js&"
import style0 from "./AlfRelatedOne.vue?vue&type=style&index=0&id=237eebd9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237eebd9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/royalbeeseg.com/Demo-4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('237eebd9')) {
      api.createRecord('237eebd9', component.options)
    } else {
      api.reload('237eebd9', component.options)
    }
    module.hot.accept("./AlfRelatedOne.vue?vue&type=template&id=237eebd9&scoped=true&", function () {
      api.rerender('237eebd9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/partial/product/related/AlfRelatedOne.vue"
export default component.exports